module.exports = __webpack_public_path__ + "img/Logan.5f5ec2aa.jpg";